import { WS_ONE_DAY } from '@pages/WorkSchedule/constants/filters';

import { periodDayCounts } from '@pages/WorkSchedule/data/periodDayCounts';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const defineDaysCount = (
  filters: React.MutableRefObject<NWorkSchedule.Filters>
): number => {
  const filterDetails = filters.current.period.detailedPeriod;
  const defaultValue = periodDayCounts.find(() => WS_ONE_DAY === filterDetails)
    ?.daysCount as number;

  return (
    periodDayCounts.find(({ id }) => id === filterDetails)?.daysCount ||
    defaultValue
  );
};
